import { AppBar, Box, Button, Toolbar } from "@mui/material";
import Logo from "../assets/images/Logo.png";
import { useNavigate } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
function Header() {
  const pathCurrent = window.location.pathname.split("/")[1];
  const navigate = useNavigate();
  const { user } = useAuth();

  const NAVIGATION = [
    {
      title: "HOME",
      segment: "home",
    },
    {
      title: "MARKETPLACE",
      segment: "marketplace",
    },
    {
      title: "สนใจสมัครร้านค้า",
      segment: "contact",
    },
  ];

  return (
    <AppBar
      position="fixed"
      sx={{ backgroundColor: "#212529", height: "76px", zIndex: 1201 }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
        <Box>
          <Box
            sx={{ height: "50px", width: "150px" }}
            component="img"
            src={Logo}
            alt="logo"
          />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          {NAVIGATION.map((item, index) => (
            <Box
              key={index}
              sx={{
                color: pathCurrent === item.segment ? "#00bb9f" : "white",
                fontSize: "20px",
                fontWeight: "medium",
                mx: 3,
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
              onClick={() => {
                navigate("/" + item.segment);
              }}
            >
              {item.title}
            </Box>
          ))}
          <Button
            className="button-two-tone"
            variant="contained"
            sx={{
              width: "150px",
              borderRadius: "12px",
              height: "40px",
              fontSize: "16px",
            }}
            onClick={() => {
              if (user) {
                const { role } = user;
                if (
                  role === "owner" ||
                  role === "AdminM" ||
                  role === "AdminA"
                ) {
                  navigate("/pawn");
                } else {
                  navigate("/admin");
                }
              } else {
                navigate("/login");
              }
            }}
          >
            เข้าสู่ระบบร้านค้า
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
